import { withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26523dba"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "language_position"
}
const _hoisted_2 = { class: "position-relative w-100 h-100" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "fade_selector"
}
const _hoisted_5 = ["src", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isActive)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "options_background",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.isActive = false), ["stop","prevent"]))
        }))
      : _createCommentVNode("", true),
    (_ctx.enabledLanguages.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: "language_selector",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isActive = !_ctx.isActive))
            }, [
              _createElementVNode("img", {
                src: '/img/flags/' + _ctx.selectedFlag + '.svg'
              }, null, 8, _hoisted_3)
            ]),
            (_ctx.isActive)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enabledLanguages, (lang) => {
                    return (_openBlock(), _createElementBlock("img", {
                      class: "flag",
                      src: '/img/flags/' + _ctx.getFlagFromLang(lang) + '.svg',
                      key: lang,
                      onClick: ($event: any) => (_ctx.selectLanguage(lang))
                    }, null, 8, _hoisted_5))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}